// React
import React, { useState } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
// Components
// Styling
import { NoAppsContainer, NoAppsContent } from './styles';
import { BitButton } from '../BitButton';
import { LicencePopup } from '../LicencePopup';

type NoAppsProps = {
  onUpgrade?: React.Dispatch<void>;
  hasTried?: boolean;
  compact?: boolean;
  tid: string;
};

const NoApps = ({ onUpgrade, hasTried, compact, tid }: NoAppsProps) => {
  const [isTrialPopupOpen, setIsTrialPopupOpen] = useState(false);

  return (
    <NoAppsContainer>
      <BrowserView>
        <NoAppsContent>
          {!compact && (
            <img alt="subscribe to add Apps here" src="emptyFolder.svg" />
          )}

          <h1>You still don't have any app :(</h1>
          <h3>
            Subscribe{!hasTried && ' or initiate a trial'} to activate your
            first app.
          </h3>

          <div className="buttonsContainer">
            <BitButton
              label="Subscribe here"
              action={() => onUpgrade && onUpgrade()}
            />

            {!hasTried && (
              <>
                <span>or</span>
                <BitButton
                  label="Try BitFractal"
                  variant="secondary"
                  action={() => setIsTrialPopupOpen(true)}
                />
              </>
            )}
          </div>

          <p>
            Please refresh this page after purchasing to load your new
            subscription.
          </p>

          <LicencePopup
            isVisible={isTrialPopupOpen}
            setIsVisible={setIsTrialPopupOpen}
            tid={tid}
            type="TRIAL"
          />

          {/* <Modal
            titleAriaId={titleId}
            isOpen={isModalOpen}
            onDismiss={hideModal}
            isBlocking={false}
            containerClassName={contentStyles.container}
          >
            <SSO isSSO={isSSO} setIsSSO={setIsSSO} />
            <div
              className={contentStyles.header}
              style={{ position: 'relative' }}
            >
              <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Close popup modal"
                onClick={hideModal}
              />
            </div>
            {isSSO && (
              <TrialModalContent>
                <h1>
                  Your 7-day trial experience is about to begin. Click the below
                  buttom to activate it:
                </h1>
                <BitButton
                  label="Initiate BitFractal Trial"
                  action={() => {
                    onTrial && onTrial();
                    hideModal();
                  }}
                />
                <p> The page will refresh to load your new subscription</p>
              </TrialModalContent>
            )}
          </Modal> */}
        </NoAppsContent>
      </BrowserView>
      <MobileView>
        <NoAppsContent isMobile>
          {!compact && (
            <img alt="subscribe to add Apps here" src="emptyFolder.svg" />
          )}
          <h1>You still don't have any app :(</h1>
          <p>
            Use the web or desktop version to subscribe
            {!hasTried && ' or initiate a trial'} and activate your first app.
          </p>
        </NoAppsContent>
      </MobileView>
    </NoAppsContainer>
  );
};
export default NoApps;
